
import { Component, Prop, Vue } from "vue-property-decorator";

enum ETripDirection {
  TwoWay = 0,
  Departure = 1,
  Return = 2
}

@Component
export default class TripDirectionsSelect extends Vue {
  @Prop({ required: true }) value: number | null;
  @Prop({ default: false }) disabled!: boolean;

  get selectedTripDirections(): number | null {
    return this.value === null || this.value === undefined ? 0 : this.value;
  }

  set selectedTripDirections(val: number | null) {
    this.$emit("input", val);
  }

  get tripDirections() {
    return [
      {
        text: this.$i18n.translate('transportationPermission.tripDirections.twoWay', 'Two way'),
        value: ETripDirection.TwoWay,
      },
      {
        text: this.$i18n.translate('transportationPermission.tripDirections.departure', 'Departure'),
        value: ETripDirection.Departure,
      },
      {
        text: this.$i18n.translate('transportationPermission.tripDirections.return', 'Return'),
        value: ETripDirection.Return,
      },
    ];
  }
}
